/*global define*/

define([
    'jquery',
    'underscore',
    'backbone',
    '../resources/vessels',
    '../resources/tools',
    '../resources/glassware',
    './App',
    '../resources/lang',
    '../../styles/local.module.scss'
],     function ($, _, Backbone, vessels, tools, glassware, AppView, lang, styles) {
    'use strict';

    require("../../styles/icons/tools.svg");
    require("../../styles/icons/solutions.svg");
    require("../../styles/icons/glassware.svg");

    var StockroomView = Backbone.View.extend({
        template: require('ejs-loader!../templates/Stockroom.ejs'),
        events: {
            'click .branch': 'branchHandler'
        },
        render: function(){
            this.$el.html(this.template({
                drawer: this.drawer,
                tools: tools,
                solutions: this.solutions,
                glassware: glassware,
                vessels: vessels,
                domain: this.domain,
                terms: _.extend({}, lang.stockroom, lang.tools, lang.glassware),
                language: language,
                styles: this.styles
            }));
            $(".stockroomTab").each(function(){
                $(this).removeClass("selected");
            });
            $("#"+this.drawer).addClass("selected");
        },
        initialize: function(options){
            this.styles = styles.default;
            this.solutions = [];//solutions;
            this.drawer = "solutions";
            this.domain = options.domain
            this.render();
        },
        open: function(){
            $("#stockroomContainer").removeClass("stockroomClosed");
            $(".stockroomTab").each(function(){
                    $(this).removeClass("selected");
            });
            $("#"+this.drawer).addClass("selected");
        },
        close: function(){
            $("#stockroomContainer").addClass("stockroomClosed");
            $(".selected").each(function(){
                    $(this).removeClass("selected");
            });
        },
        switchTab : function(tab){
            this.drawer = tab;
            this.render();
        },
        loadSolutions: function(solutions){
            this.solutions = solutions;
            this.render();
        },
        branchHandler: function(event){
            event.stopPropagation()
            var node = $(event.currentTarget);
            var content = $("#branchContent"+node.attr("id"));
            if (node.hasClass("collapsed")){
                node.removeClass("collapsed");
                node.addClass("expanded");
                node.children().each(function(){
                    if ($(this).hasClass("glyphicon")){
                        $(this).addClass("glyphicon-chevron-down");
                        $(this).removeClass("glyphicon-chevron-right")
                    }
                });
                content.css("display", "block");
            }
            else if (node.hasClass("expanded")){
                node.removeClass("expanded");
                node.addClass("collapsed");
                node.children().each(function(){
                    if ($(this).hasClass("glyphicon")){
                        $(this).addClass("glyphicon-chevron-right");
                        $(this).removeClass("glyphicon-chevron-down")
                    }
                });
                content.css("display", "none");
            }
        }
    });
    return StockroomView;
});
